const scrollBeforeLoad = (scrollTo, scrollingElement) => {
  if (scrollTo) {
    const element = scrollingElement || document.scrollingElement;
    element.scrollTo(0, scrollTo);
    preventTurboOverridingScroll();
  }
};
const preventTurboOverridingScroll = () => {
  if (Turbo.navigator.currentVisit) {
    Turbo.navigator.currentVisit.scrolled = true;
  }
};
export default scrollBeforeLoad;